module.exports = __webpack_public_path__ + "img/ceshi8.b616ecfe.png";